import { render, staticRenderFns } from "./InspirationPreview.vue?vue&type=template&id=1c40a354"
import script from "./InspirationPreview.vue?vue&type=script&lang=js"
export * from "./InspirationPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports